export const makeNumber = value => {
  if (!value) {
    return 0
  }

  return parseInt(value.toString().replace(/\D/g, ''))
}
